import { List } from 'immutable';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';

const messages = {
    requiredFields: LanguageUtils.createMessage('Agreement version is required')
};

export default class AgreementStep3Validation extends ValidationUtils {
    static validateSelectedAgreementVersion(agreementVersionId?: number): boolean {
        return !!agreementVersionId;
    }

    static validateAddAgreementVersionForm(agreementVersionId?: number): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const requiredFields = AgreementStep3Validation.validateSelectedAgreementVersion(agreementVersionId);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
    }
}
